import styled, { css } from 'styled-components';
import { generateScales } from '@helpers/generate-media-queries';
import { TextLink } from '@components/text-link.styled';

export const Container = styled.div`
  width: 100%;
`;

export const NavWrapper = styled.nav`
  ${({ theme }) => css`
    margin: 0 auto;
    width: fit-content;
    display: flex;
    align-items: center;
    padding: 1.25rem 1.5rem;
    column-gap: 1rem;
    background-color: ${theme.colors.light};
    border-radius: ${theme.borderRadius.large};
    z-index: ${theme.zIndex.navbar - 1};

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 0.5rem 1rem;
      border: none;
      justify-content: space-between;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
      grid-template-columns: minmax(auto, 5rem) auto minmax(auto, 5rem);
      column-gap: 0.25rem;
    }
  `}
`;

export const NavBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    column-gap: 1rem;
    row-gap: 1rem;
    padding: 0 0 0 1rem;
    border-left: 1.5px solid ${theme.colors.dark}33;
    height: 100%;
    align-items: center;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      border-left: none;
      border-right: none;
      padding: 0;
      justify-content: center;
    }
  `}
`;

export const NavLink = styled.a<{ isDisabled?: boolean; isActive?: boolean }>`
  ${({ theme, isDisabled, isActive }) => css`
    font-family: ${theme.fontFamily.text};
    ${generateScales('font-size', '1rem', '1rem', theme)}
    line-height: ${theme.lineHeights.base};
    color: ${theme.colors.secondary};
    text-decoration: none;
    padding: 0;
    margin: 0;
    text-wrap: nowrap;
    text-underline-offset: 3px;
    text-decoration-thickness: 1.5px;
    text-decoration-color: ${theme.colors.primary};

    &:hover {
      text-decoration: underline;
    }

    ${isDisabled &&
    css`
      pointer-events: none;
      color: rgba(0, 0, 0, 0.5);
    `}

    ${isActive &&
    css`
      cursor: default;
      color: ${theme.colors.dark};
      text-decoration: none;
      pointer-events: none;
      ${TextLink(theme.colors.white)}
    `}
  `}
`;

export const PrevNavLink = styled(NavLink)`
  text-align: right;
`;

export const NumberLink = styled(NavLink)`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const DropdownWrapper = styled.div`
  ${({ theme }) => css`
    width: 10rem;

    @media only screen and (min-width: ${theme.breakpoints.lg}) {
      display: none;
    }
  `}
`;

export const PageSelect = styled.select`
  ${({ theme }) => css`
    width: 100%;
    padding: 0.625rem 2.5rem 0.625rem 0.75rem;
    border-radius: ${theme.borderRadius.normal};
    border: 1px solid ${theme.colors.dark}33;
    background-color: ${theme.colors.white};
    font-family: ${theme.fontFamily.text};
    ${generateScales('font-size', '1rem', '1rem', theme)}
    line-height: ${theme.lineHeights.base};
    color: ${theme.colors.dark};
    cursor: pointer;
    appearance: none;

    background-image: linear-gradient(45deg, transparent 50%, ${theme.colors.dark} 50%),
      linear-gradient(135deg, ${theme.colors.dark} 50%, transparent 50%);
    background-position: calc(100% - 1.25rem) center, calc(100% - 1rem) center;
    background-size: 5px 5px, 5px 5px;
    background-repeat: no-repeat;

    &:focus {
      outline: none;
      border-color: ${theme.colors.primary};
      box-shadow: 0 0 0 2px ${theme.colors.primary}33;
    }
  `}
`;

export const PageList = styled.ol`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    column-gap: 1rem;
    row-gap: 1rem;
    list-style: none;
    margin: 0;
    padding: 0;
    height: 100%;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      display: none;
    }
  `}
`;

export const PageItem = styled.li`
  ${({ theme }) => css`
    display: flex;
    padding-right: 1rem;
    height: 100%;
    align-items: center;

    @media only screen and (min-width: ${theme.breakpoints.lg}) {
      border-right: 1.5px solid ${theme.colors.dark}33;
    }
  `}
`;
